var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-progress-circular',_vm._g(_vm._b({attrs:{"size":"56","color":_vm.color,"indeterminate":"","width":"6"}},'v-progress-circular',_vm.$attrs,false),_vm.$listeners))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }